import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = {
  key: 0,
  class: "card mb-5 xl-3"
}
const _hoisted_3 = { class: "card-body border-top p-9" }
const _hoisted_4 = { class: "d-flex flex-stack" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = { class: "nav nav-tabs nav-line-tabs mb-5 fs-5" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Data Konfirmasi Invoice"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Daftar Konfirmasi Invoice")
  ])
], -1)
const _hoisted_10 = { class: "d-flex px-8 mt-5" }
const _hoisted_11 = { class: "card-body py-3" }
const _hoisted_12 = {
  key: 0,
  class: "row mb-4"
}
const _hoisted_13 = {
  key: 0,
  class: "col-sm-7 px-3"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Pilih Sekolah", -1)
const _hoisted_15 = { class: "row mb-4" }
const _hoisted_16 = {
  key: 0,
  class: "col-4 px-3"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Status", -1)
const _hoisted_18 = {
  key: 1,
  class: "col-4 px-3"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Pilih Sekolah", -1)
const _hoisted_20 = {
  key: 2,
  class: "col-4 px-3"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Tanggal Awal", -1)
const _hoisted_22 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_23 = {
  key: 3,
  class: "col-4 px-3"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Tanggal Akhir", -1)
const _hoisted_25 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_26 = { class: "table-responsive" }
const _hoisted_27 = { class: "table align-middle gs-0 gy-4 table-striped table-hover" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Sekolah"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tagihan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "No Tagihan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Total"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "PIC"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Pengiriman"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tujuan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Aksi")
  ])
], -1)
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "text-left" }
const _hoisted_31 = { class: "text-left" }
const _hoisted_32 = { class: "text-left" }
const _hoisted_33 = { class: "text-left" }
const _hoisted_34 = { class: "text-left" }
const _hoisted_35 = { class: "text-left" }
const _hoisted_36 = { class: "text-left" }
const _hoisted_37 = { class: "text-left" }
const _hoisted_38 = {
  key: 0,
  class: "text-left"
}
const _hoisted_39 = {
  key: 1,
  class: "text-left"
}
const _hoisted_40 = {
  key: 2,
  class: "text-left"
}
const _hoisted_41 = {
  key: 3,
  class: "text-center"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  key: 4,
  class: "text-center"
}
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { key: 1 }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "12",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { class: "row mt-5 mb-5" }
const _hoisted_49 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_50 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_51 = ["label", "value"]
const _hoisted_52 = { class: "p-3" }
const _hoisted_53 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_54 = { class: "pagination" }
const _hoisted_55 = {
  class: "modal fade",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  id: "kt_modal_confirm_legal"
}
const _hoisted_56 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_57 = { class: "modal-content rounded" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header pb-0 border-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Detail Konfirmasi Finance"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Data Proses")
  ])
], -1)
const _hoisted_59 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "col-xl-6 mb-8" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Sekolah", -1)
const _hoisted_63 = { class: "col-xl-6 mb-8" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Tagihan", -1)
const _hoisted_65 = { class: "row" }
const _hoisted_66 = { class: "col-xl-6 mb-8" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Nomor Tagihan", -1)
const _hoisted_68 = { class: "col-xl-6 mb-8" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Tanggal Pembayaran", -1)
const _hoisted_70 = { class: "row" }
const _hoisted_71 = { class: "col-xl-6 mb-8" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Jumlah tagihan", -1)
const _hoisted_73 = { class: "row" }
const _hoisted_74 = { class: "col-xl-6 mb-8" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Penanggung Jawab", -1)
const _hoisted_76 = { class: "col-xl-6 mb-8" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Eksekutor", -1)
const _hoisted_78 = { class: "row" }
const _hoisted_79 = { class: "col-xl-6 mb-8" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Nama Rekening Pengirim", -1)
const _hoisted_81 = { class: "col-xl-6 mb-8" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Rekening Tujuan", -1)
const _hoisted_83 = { class: "row" }
const _hoisted_84 = { class: "col-xl-6 mb-8" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Eksekutor Finance", -1)
const _hoisted_86 = { class: "col-xl-6 mb-8" }
const _hoisted_87 = ["src"]
const _hoisted_88 = { class: "row" }
const _hoisted_89 = {
  key: 0,
  class: "col-xl-12 mb-8"
}
const _hoisted_90 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Catatan", -1)
const _hoisted_91 = {
  key: 0,
  class: "col-xl-12 mb-2"
}
const _hoisted_92 = /*#__PURE__*/_createElementVNode("span", { class: "form-label fw-bolder text-dark fs-6" }, "Persetujuan Finance", -1)
const _hoisted_93 = [
  _hoisted_92
]
const _hoisted_94 = {
  key: 1,
  class: "col-xl-12"
}
const _hoisted_95 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Silahkan dicek kembali apakah tagihan sudah dibayar atau belum", -1)
const _hoisted_96 = [
  _hoisted_95
]
const _hoisted_97 = {
  key: 2,
  class: "col-xl-6"
}
const _hoisted_98 = {
  class: "btn-group btn-sm",
  role: "group",
  "aria-label": "Basic checkbox toggle button group"
}
const _hoisted_99 = {
  type: "button",
  class: "btn btn-sm",
  style: {"border-width":"4px"}
}
const _hoisted_100 = /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline-primary",
  for: "accept"
}, "Diterima", -1)
const _hoisted_101 = {
  type: "button",
  class: "btn btn-sm"
}
const _hoisted_102 = /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline-danger",
  for: "reject",
  style: {"color":"#000"}
}, "Ditolak", -1)
const _hoisted_103 = { class: "row" }
const _hoisted_104 = {
  key: 0,
  class: "col-12"
}
const _hoisted_105 = {
  key: 0,
  class: "fs-6 alert alert-danger text-danger"
}
const _hoisted_106 = {
  key: 1,
  class: "fs-6 alert alert-dark text-dark"
}
const _hoisted_107 = {
  key: 2,
  class: "fs-6 alert alert-primary text-primary"
}
const _hoisted_108 = {
  key: 0,
  class: "modal-footer"
}
const _hoisted_109 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-danger",
  "data-bs-dismiss": "modal",
  style: {"background-color":"#e50200"}
}, " Batal ", -1)
const _hoisted_110 = {
  key: 1,
  class: "modal-footer"
}
const _hoisted_111 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-danger",
  "data-bs-dismiss": "modal",
  style: {"background-color":"#e50200"}
}, " Batal ", -1)
const _hoisted_112 = [
  _hoisted_111
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    (
      [
        'ADMIN_FINANCE',
        'SUPER_ADMIN',
        'SALES_AREA',
        'SALES_LEADER',
        'CS_LEADER',
        'CS_MEMBER',
        'IMPLEMENTATOR_LEADER',
        'IMPLEMENTATOR_MEMBER',
      ].includes(_ctx.roleuser)
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("ul", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listConfirmation, (el) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "nav-item",
                      key: el.value
                    }, [
                      (el.value == _ctx.status)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "nav-link active fs-5 text-dark text-hover-primary fw-bolder text-active-primary me-6",
                            "data-bs-toggle": "tab",
                            onClick: ($event: any) => (_ctx.pilihStatus(el.value)),
                            style: {"cursor":"pointer"}
                          }, _toDisplayString(el.label), 9, _hoisted_7))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            class: "nav-link fs-5 text-dark text-hover-primary fw-bolder text-active-primary me-6",
                            "data-bs-toggle": "tab",
                            onClick: ($event: any) => (_ctx.pilihStatus(el.value)),
                            style: {"cursor":"pointer"}
                          }, _toDisplayString(el.label), 9, _hoisted_8))
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          class: "btn btn-sm btn-light",
          style: {"font-weight":"400","margin-top":"0px"},
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showHideFilter && _ctx.showHideFilter(...args)))
        }, " Filter ")
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.roleuser !== 'ADMIN_SCHOOL' && _ctx.roleuser !== 'ADMIN_FINANCE')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_ctx.showFilter)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.schoolId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.schoolId) = $event)),
                      placeholder: "Pilih Sekolah",
                      mode: "single",
                      "create-option": false,
                      options: _ctx.listSekolah,
                      searchable: true,
                      label: "name",
                      "track-by": "name",
                      "value-prop": "_id",
                      "max-height": 350,
                      max: 5,
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pilihSekolah($event)))
                    }, null, 8, ["modelValue", "options"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_15, [
          (_ctx.showFilter && _ctx.roleuser != 'ADMIN_FINANCE')
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.status,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.status) = $event)),
                  placeholder: "Status",
                  mode: "single",
                  "create-option": false,
                  options: _ctx.listConfirmation,
                  searchable: true,
                  label: "label",
                  "track-by": "value",
                  "value-prop": "value",
                  "max-height": 350,
                  max: 5,
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.pilihStatus($event)))
                }, null, 8, ["modelValue", "options"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showFilter && _ctx.roleuser === 'ADMIN_FINANCE')
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.schoolId,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.schoolId) = $event)),
                  placeholder: "Pilih Sekolah",
                  mode: "single",
                  "create-option": false,
                  options: _ctx.listSekolah,
                  searchable: true,
                  label: "name",
                  "track-by": "name",
                  "value-prop": "_id",
                  "max-height": 350,
                  max: 5,
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.pilihSekolah($event)))
                }, null, 8, ["modelValue", "options"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showFilter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _hoisted_21,
                _createVNode(_component_Field, {
                  type: "date",
                  name: "tanggal",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Tanggal Pembayaran",
                  modelValue: _ctx.startDate,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.startDate) = $event)),
                  onChange: _ctx.onDateFilterChange
                }, null, 8, ["modelValue", "onChange"]),
                (_ctx.status !== 'WAIT' && !_ctx.startDate)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Harap mengisi tanggal terlebih dahulu"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.showFilter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _hoisted_24,
                _createVNode(_component_Field, {
                  type: "date",
                  name: "endate",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Tanggal Pembayaran",
                  modelValue: _ctx.endDate,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.endDate) = $event)),
                  onChange: _ctx.onDateFilterChange
                }, null, 8, ["modelValue", "onChange"]),
                (_ctx.status !== 'WAIT' && !_ctx.endDate)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Harap mengisi tanggal terlebih dahulu"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("table", _hoisted_27, [
            _hoisted_28,
            (_ctx.tableData.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_30, _toDisplayString(item.schoolName), 1),
                      _createElementVNode("td", _hoisted_31, _toDisplayString(item.item), 1),
                      _createElementVNode("td", _hoisted_32, _toDisplayString(item.number), 1),
                      _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.dateTime2(item.paymentDate)), 1),
                      _createElementVNode("td", _hoisted_34, "Rp. " + _toDisplayString(_ctx.formatPrice(item.amount)), 1),
                      _createElementVNode("td", _hoisted_35, _toDisplayString(item.pic), 1),
                      _createElementVNode("td", _hoisted_36, _toDisplayString(item.bankNameSender), 1),
                      _createElementVNode("td", _hoisted_37, _toDisplayString(item.bankNameTo), 1),
                      (item.status == 'REJECT')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_38, _toDisplayString("Ditolak")))
                        : (item.status == 'ACCEPT')
                          ? (_openBlock(), _createElementBlock("td", _hoisted_39, _toDisplayString("Diterima")))
                          : (_openBlock(), _createElementBlock("td", _hoisted_40, _toDisplayString("Menunggu Konfirmasi Finance"))),
                      (item.status == 'WAIT')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_41, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-primary btn-sm mr-8",
                              title: "Konfirmasi",
                              onClick: ($event: any) => (_ctx.getId(index, item)),
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#kt_modal_confirm_legal"
                            }, _toDisplayString([
                        "SALES_AREA",
                        "SALES_LEADER",
                        "CS_LEADER",
                        "CS_MEMBER",
                        "IMPLEMENTATOR_LEADER",
                        "IMPLEMENTATOR_MEMBER",
                      ].includes(this.roleuser)
                        ? "Detail"
                        : "Konfirmasi"), 9, _hoisted_42)
                          ]))
                        : (_openBlock(), _createElementBlock("td", _hoisted_43, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-primary btn-sm",
                              style: {"background-color":"#52d5ff"},
                              title: "Detail",
                              onClick: ($event: any) => (_ctx.getId(index, item)),
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#kt_modal_confirm_legal"
                            }, _toDisplayString("Detail"), 8, _hoisted_44)
                          ]))
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_45, _hoisted_47))
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changePageSize()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, _hoisted_51))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_52, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("ul", _hoisted_54, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_55, [
      _createElementVNode("div", _hoisted_56, [
        _createElementVNode("div", _hoisted_57, [
          _hoisted_58,
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _hoisted_62,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "school",
                  class: "form-control form-control-lg",
                  modelValue: _ctx.formDetail.schoolName,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formDetail.schoolName) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_63, [
                _hoisted_64,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "tagihan",
                  class: "form-control form-control-lg",
                  modelValue: _ctx.formDetail.item,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formDetail.item) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _hoisted_67,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "number",
                  class: "form-control form-control-lg",
                  modelValue: _ctx.formDetail.number,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formDetail.number) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_68, [
                _hoisted_69,
                _createVNode(_component_Field, {
                  type: "text",
                  class: "form-control form-control-lg",
                  name: "paymentdate",
                  modelValue: _ctx.formDetail.paymentDate,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formDetail.paymentDate) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("div", _hoisted_71, [
                _hoisted_72,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "amount",
                  class: "form-control form-control-lg",
                  modelValue: _ctx.formDetail.amount,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formDetail.amount) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("div", _hoisted_74, [
                _hoisted_75,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "pic",
                  class: "form-control form-control-lg",
                  modelValue: _ctx.formDetail.pic,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formDetail.pic) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_76, [
                _hoisted_77,
                _createVNode(_component_Field, {
                  type: "text",
                  class: "form-control form-control-lg",
                  name: "executor",
                  modelValue: _ctx.formDetail.executor,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formDetail.executor) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("div", _hoisted_79, [
                _hoisted_80,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "banknamesender",
                  class: "form-control form-control-lg",
                  modelValue: _ctx.formDetail.bankNameSender,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formDetail.bankNameSender) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_81, [
                _hoisted_82,
                _createVNode(_component_Field, {
                  type: "text",
                  class: "form-control form-control-lg",
                  name: "banknumbto",
                  modelValue: _ctx.formDetail.bankNumbTo,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formDetail.bankNumbTo) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("div", _hoisted_84, [
                _hoisted_85,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "financeExecutor",
                  class: "form-control form-control-lg",
                  modelValue: _ctx.formDetail.financeExecutor,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formDetail.financeExecutor) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_86, [
                _createElementVNode("img", {
                  alt: "filepersonal",
                  class: "pl-3",
                  style: {"max-width":"300px"},
                  src: _ctx.fotoforensik
                }, null, 8, _hoisted_87)
              ])
            ]),
            _createElementVNode("div", _hoisted_88, [
              (_ctx.roleuser === 'SUPER_ADMIN' || _ctx.roleuser === 'ADMIN_FINANCE')
                ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                    _hoisted_90,
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control form-control-lg",
                      type: "text",
                      placeholder: "Tambahkan Catatan Untuk Konfirmasi Perubahan",
                      name: "note",
                      autocomplete: "off",
                      rows: "2",
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formDetail.note) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.formDetail.note]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.roleuser === 'SUPER_ADMIN' || _ctx.roleuser === 'ADMIN_FINANCE')
              ? (_openBlock(), _createElementBlock("div", _hoisted_91, _hoisted_93))
              : _createCommentVNode("", true),
            (_ctx.roleuser === 'SUPER_ADMIN' || _ctx.roleuser === 'ADMIN_FINANCE')
              ? (_openBlock(), _createElementBlock("div", _hoisted_94, _hoisted_96))
              : _createCommentVNode("", true),
            (_ctx.roleuser === 'SUPER_ADMIN' || _ctx.roleuser === 'ADMIN_FINANCE')
              ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("button", _hoisted_99, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        class: "btn-check",
                        value: "accept",
                        id: "accept",
                        autocomplete: "off",
                        checked: "",
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formDetail.status) = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.formDetail.status]
                      ]),
                      _hoisted_100
                    ]),
                    _createElementVNode("button", _hoisted_101, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        class: "btn-check",
                        value: "reject",
                        id: "reject",
                        autocomplete: "off",
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formDetail.status) = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.formDetail.status]
                      ]),
                      _hoisted_102
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_103, [
              (
                [
                  'SALES_AREA',
                  'SALES_LEADER',
                  'CS_LEADER',
                  'CS_MEMBER',
                  'IMPLEMENTATOR_LEADER',
                  'IMPLEMENTATOR_MEMBER',
                ].includes(this.roleuser)
              )
                ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                    (this.formDetail.status == 'REJECT')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_105, "DITOLAK "))
                      : _createCommentVNode("", true),
                    (this.formDetail.status == 'WAIT')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_106, "MENUNGGU PERSETUJUAN "))
                      : _createCommentVNode("", true),
                    (this.formDetail.status == 'ACCEPT')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_107, "DITERIMA "))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.roleuser === 'SUPER_ADMIN' || _ctx.roleuser === 'ADMIN_FINANCE')
            ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                _hoisted_109,
                (_ctx.oldStatus == 'WAIT')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-primary",
                      onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.submitAdd()))
                    }, " Simpan "))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_110, _hoisted_112))
        ])
      ])
    ])
  ], 64))
}